import avtr from '../media/user.png'

import { GetAuthUser } from '../services/user-accounts';


export default function UserInfoCard() {

  const asset = JSON.parse(localStorage.getItem("user"));
  console.log(asset)
  
  return (
    <>
    <div className="card rounded-wd bg-white">
      <div className="row g-0">
        <div className="p-3" style={{width:"fit-content"}}>
          <img 
            src={avtr} 
            style={{width:"2.7rem"}}
            className="rounded-circle" alt="...">
          </img>
        </div>

        <div className="col">
          <div className="card-body ps-0">
            <p className="fw-bold m-0 p-0">{asset.name}</p>
            <p className="m-0 p-0">
              <small className="">{asset.mail}</small>
            </p>
            <p className="m-0 p-0">
              <small className="">{asset.usid}</small>
            </p>
          </div>
        </div>

      </div>
    </div>


    </>
  )
}